import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import {
    TextField,
    Button,
    Grid,
    Box,
    Typography,
    FormControl,
    InputLabel,
    Select,
    OutlinedInput,
    MenuItem,
    CircularProgress
} from '@material-ui/core'
import {
    DropZoneMultiple
} from './../components'
import { CustomSnackBar } from './../components'
import axios from './../plugins/axios'

const styles = theme => ({
    marginLeft: {
        margin: '0 10px 0 0'
    },
    marginBottom: {
        margin: '0 0 20px 0'
    }
})

class DestinationForm extends Component {

    static defaultProps = {
        name: '',
        images: [],
        description: '',
        attractions: [],
        attraction_ids: []
    }

    constructor(props) {
        super(props)

        const {
            name,
            description,
            images,
            attractions,
            attraction_ids
        } = props

        this.state = {
            fetching: false,
            disabled: false,
            isSnackOpen: false,
            errors: {},
            name,
            description,
            images,
            attractions,
            attraction_ids
        }
    }

    handleChange = name => e => {
        this.setState({
            [name]: e.target.value
        })
    }

    reset = () => {
        this.setState({
            errors: {},
            name: '',
            images: [],
            description: '',
            attraction_ids: []
        })
    }

    storeOrUpdate = async e => {
        e.preventDefault()
        this.setState({
            disabled: true,
            errors: {}
        })

        const {
            path,
            method
        } = this.props

        const {
            name,
            description,
            images,
            attraction_ids
        } = this.state

        try {
            await axios[method](path, {
                name,
                description,
                images,
                attraction_ids
            })

            this.setState({
                isSnackOpen: true
            })

            if (method === 'post') {
                this.reset()
            }

            this.setState({
                disabled: false
            })
        } catch (err) {
            if (err.response.status === 422) {
                const { errors } = err.response.data
                this.setState({ errors })
            }
        }
    }

    snackClose = () => {
        this.setState({
            isSnackOpen: false
        })
    }

    onChange = (path, bool) => {
        let copyImages = []
        if (bool === undefined) {
            this.setState(prevState => ({
                images: [...prevState.images, path]
            }))
        } else {
            copyImages = this.state.images.filter(val =>
                val !== path
            )
            this.setState({
                images: copyImages
            })
        }
    }

    selectChanged = e => {
        const { value } = e.target

        this.setState({ attraction_ids: value })
    }

    render() {
        const {
            name,
            description,
            images,
            attractions,
            attraction_ids,
            isSnackOpen,
            errors,
            disabled
        } = this.state

        const {
            message
        } = this.props

        return (
            <div>
                <form
                    onSubmit={this.storeOrUpdate}
                >
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <TextField
                                error={!!errors.name}
                                helperText={errors.name}
                                label="Нэр"
                                value={name}
                                onChange={this.handleChange('name')}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                            />
                            <TextField
                                error={!!errors.description}
                                helperText={errors.description}
                                label="Дэлгэрэнгүй"
                                value={description}
                                onChange={this.handleChange('description')}
                                variant="outlined"
                                margin="normal"
                                multiline
                                rows={7}
                                fullWidth
                            />
                            <Box my={3}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel htmlFor="attraction_ids-simple">Attractions</InputLabel>
                                    <Select
                                        error={!!errors.attraction_ids}
                                        helperText={errors.attraction_ids}
                                        labelId="attraction_ids-simple"
                                        multiple
                                        value={attraction_ids}
                                        onChange={this.selectChanged}
                                        input={
                                            <OutlinedInput />
                                        }
                                    >
                                        {
                                            attractions.map(val =>
                                                <MenuItem
                                                    key={val.id}
                                                    value={val.id}
                                                >
                                                    {val.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box my={3}>
                                <Typography variant="subtitle1">Зураг</Typography>
                                <DropZoneMultiple
                                    uploadPath="img/upload"
                                    onChange={this.onChange}
                                    files={images}
                                    error={!!errors.images}
                                />
                            </Box>
                            <Box my={3}>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    type="submit"
                                    disabled={disabled}
                                >
                                    {
                                        disabled ? <CircularProgress size={25} color="primary" /> : "Хадгалах"
                                    }
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                    <CustomSnackBar
                        message={message}
                        open={isSnackOpen}
                        snackClose={this.snackClose}
                    />
                </form>
            </div>
        )
    }
}

export default withStyles(styles)(DestinationForm)
